let PARENT_URL = '*';

export function postMessageSender(payload, parentOrigin = PARENT_URL) {
  const isInIframe = window.location !== window.parent.location;

  if (isInIframe) {
    PARENT_URL = parentOrigin !== '*' ? parentOrigin : PARENT_URL;

    const serialized = JSON.stringify(payload);
    window.parent.postMessage(serialized, PARENT_URL);
  }
}
